import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { stateApi, lifeStateApi, wellnessStateApi } from "@/lib/api";
import { toast } from "sonner";

const CentralStateContext = createContext(null);

export const CentralStateProvider = ({ children }) => {
  const [fin, setFin] = useState(null);
  const [life, setLife] = useState(null);
  const [wellness, setWellness] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [f, l, w] = await Promise.all([
        stateApi.get().catch(() => ({ state: {} })),
        lifeStateApi.get().catch(() => ({ state: {} })),
        wellnessStateApi.get().catch(() => ({ state: {} })),
      ]);
      setFin(f.state || {});
      setLife(l.state || {});
      setWellness(w.state || {});
    } catch {
      toast.error("Could not load your combined data");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <CentralStateContext.Provider value={{ fin, life, wellness, loading, reload: load }}>
      {children}
    </CentralStateContext.Provider>
  );
};

export const useCentralState = () => useContext(CentralStateContext);
